$('body').on('click', '.idCard', function (e) {
  if ($(e.target).is('a')) {
    return;
  } else {
    $(this).toggleClass('flipped');
    $('.ht-IdCard-contentPlace').toggleClass('flipped');
  }
});
